import { action } from 'typesafe-actions';
import {
  GET_STATS_REQUEST,
  GET_STATS_FAILURE,
  GET_STATS_SUCCESS,
  DOWNLOAD_ALL_CSV_SUCCESS,
  DOWNLOAD_ALL_CSV_FAILURE,
  DOWNLOAD_ALL_CSV_REQUEST,
  PUT_PAYOUTS_METHOD_FAILURE,
  PUT_PAYOUTS_METHOD_REQUEST,
  PUT_PAYOUTS_METHOD_SUCCESS,
  GET_SALES_REQUEST,
  GET_SALES_SUCCESS,
  GET_SALES_FAILURE,
  SALES_NEXT_PAGE_SUCCESS,
  GET_BALANCE_REQUEST,
  GET_BALANCE_SUCCESS,
  GET_BALANCE_FAILURE,
  BALANCE_NEXT_PAGE_SUCCESS,
  PUT_BALANCE_REQUEST,
  PUT_BALANCE_SUCCESS,
  PUT_BALANCE_FAILURE,
  TIPSTER_FEE_TIERS_FAILURE,
  TIPSTER_FEE_TIERS_REQUEST,
  TIPSTER_FEE_TIERS_SUCCESS,
  UPDATE_BALANCE_OPTIMISTIC,
  ADD_TRANSACTION_OPTIMISTIC,
  REMOVE_TRANSACTION_OPTIMISTIC,
} from '../../constants/dashboard';
import {
  BalanceData,
  FeeTier,
  SalesData,
  SalesDataFromAPI,
} from '../../sagas/dashboard/types';

export const tipsterFeeTiersRequestAction = (e: any) =>
  action(TIPSTER_FEE_TIERS_REQUEST, e);
export const tipsterFeeTiersSuccessAction = (data: FeeTier[]) =>
  action(TIPSTER_FEE_TIERS_SUCCESS, data);
export const tipsterFeeTiersFailureAction = (e: any) =>
  action(TIPSTER_FEE_TIERS_FAILURE, e.detail || e.message);

export const salesRequestAction = (query: string) =>
  action(GET_SALES_REQUEST, query);
export const salesSuccessAction = (data: SalesDataFromAPI) =>
  action(GET_SALES_SUCCESS, new SalesData(data));
export const salesFailureAction = (e: any) =>
  action(GET_SALES_FAILURE, e.detail || e.message);
export const salesNextPageSuccessAction = (data: any) =>
  action(SALES_NEXT_PAGE_SUCCESS, new SalesData(data));

export const balanceRequestAction = (query: string) =>
  action(GET_BALANCE_REQUEST, query);
export const balanceSuccessAction = (data: BalanceData) =>
  action(GET_BALANCE_SUCCESS, data);
export const balanceFailureAction = (e: any) =>
  action(GET_BALANCE_FAILURE, e.detail || e.message);
export const putBalanceRequestAction = (query: string) =>
  action(PUT_BALANCE_REQUEST, query);
export const putBalanceSuccessAction = (data: any) =>
  action(PUT_BALANCE_SUCCESS, data);
export const putBalanceFailureAction = (e: any) =>
  action(PUT_BALANCE_FAILURE, e.detail || e.message);
export const balanceNextPageSuccessAction = (data: BalanceData) =>
  action(BALANCE_NEXT_PAGE_SUCCESS, data);

export const editPayoutMethodRequestAction = (data: any) =>
  action(PUT_PAYOUTS_METHOD_REQUEST, data);
export const editPayoutMethodSuccessAction = (data: any) =>
  action(PUT_PAYOUTS_METHOD_SUCCESS, data);
export const editPayoutMethodFailureAction = (e: any) =>
  action(PUT_PAYOUTS_METHOD_FAILURE);
export const statsRequestAction = (query: string) =>
  action(GET_STATS_REQUEST, query);
export const statsSuccessAction = (data: any) =>
  action(GET_STATS_SUCCESS, data);
export const statsFailureAction = (e: any) =>
  action(GET_STATS_FAILURE, e.detail || e.message);
export const downloadAllCsvSuccessAction = (data: any) =>
  action(DOWNLOAD_ALL_CSV_SUCCESS, data);
export const downloadAllCsvFailureAction = (e: any) =>
  action(DOWNLOAD_ALL_CSV_FAILURE, e.detail || e.message);
export const downloadAllCsvRequestAction = (e: any) =>
  action(DOWNLOAD_ALL_CSV_REQUEST, e);
export const updateBalanceOptimisticAction = (balanceSummary: any) =>
  action(UPDATE_BALANCE_OPTIMISTIC, balanceSummary);
export const addTransactionOptimisticAction = (transaction: any) =>
  action(ADD_TRANSACTION_OPTIMISTIC, transaction);
export const removeTransactionOptimisticAction = (transactionId: string) =>
  action(REMOVE_TRANSACTION_OPTIMISTIC, transactionId);
export const dashboardActions = {
  tipsterFeeTiersRequestAction,
  tipsterFeeTiersSuccessAction,
  tipsterFeeTiersFailureAction,
  salesRequestAction,
  salesSuccessAction,
  salesFailureAction,
  salesNextPageSuccessAction,
  balanceRequestAction,
  balanceSuccessAction,
  balanceFailureAction,
  putBalanceRequestAction,
  putBalanceSuccessAction,
  putBalanceFailureAction,
  balanceNextPageSuccessAction,
  // deprecated under tipster_progressive_fees feature flag.
  editPayoutMethodRequestAction,
  // deprecated under tipster_progressive_fees feature flag.
  editPayoutMethodFailureAction,
  // deprecated under tipster_progressive_fees feature flag.
  editPayoutMethodSuccessAction,
  statsRequestAction,
  statsSuccessAction,
  statsFailureAction,
  downloadAllCsvRequestAction,
  downloadAllCsvSuccessAction,
  downloadAllCsvFailureAction,
  updateBalanceOptimisticAction,
  addTransactionOptimisticAction,
  removeTransactionOptimisticAction,
};
